import React, {useMemo}								from 'react';
import {Route, Routes, useParams}					from 'react-router-dom';

import Header										from '../Header/Header';
import Order										from './Order';
import OrderNew										from './OrderNew';

import {useAppSelector}								from '../app/hooks';
import useWindowSize								from '../ressources/functions/useWindowSize';

import LANGUAGE										from '../ressources/language';

import './Order.css';

interface Props {
	limited?: boolean
}

function MainOrder(props: Props) {
	const orders = useAppSelector(state => state.order.data);
	const lang = useAppSelector(state => state.settings.lang);

	const params = useParams();
	const sizes = useWindowSize();
	const isComputer = sizes.width > 767;
	const TEXTE = LANGUAGE(lang);
	const MENU_DATA = [
		{value: '', render: TEXTE.header.order.myOrders},
		{value: 'catalog', render: TEXTE.header.order.catalog}
	];

	const countCurrent = useMemo(() => {
		let result = 0;

		orders.forEach((order) => {
			order.addressList.forEach((addressData) => {
				if (addressData.status.name !== 'refusedByValala' && addressData.status.name !== 'refusedByFunder' && addressData.status.name !== 'delivered')
					result++;
			});
		});
		return result;
	}, [orders]);

	return (
		<div className={'globalContainerWithHeader'}>
			{isComputer &&
				<Header
					basket={!props.limited}
					menuValue={params['*']}
					menu={!props.limited ? MENU_DATA : undefined}
					title={!props.limited ? TEXTE.order.title : TEXTE.order.titleLimited}
					badgeText={!props.limited ? `${countCurrent} ${TEXTE.order.current}` : ''}
				/>
			}

			<Routes>
				{(!props.limited) && <Route path={'/'} element={<Order />} />}
				{(isComputer && !props.limited) && <Route path={'/catalog'} element={<OrderNew />} />}
				{(isComputer && !props.limited) && <Route path={'/catalog/:step'} element={<OrderNew />} />}
				{(!props.limited) && <Route path={'/:idOrder'} element={<Order />} />}
				<Route path={'/:idOrder/:indexAddress'} element={<Order limited={props.limited} />} />
			</Routes>
		</div>
	);
}

export default MainOrder;
